import { render, staticRenderFns } from "./FiltersBox.vue?vue&type=template&id=2fb247f8&scoped=true"
import script from "./FiltersBox.vue?vue&type=script&lang=js"
export * from "./FiltersBox.vue?vue&type=script&lang=js"
import style0 from "./FiltersBox.vue?vue&type=style&index=0&id=2fb247f8&prod&lang=stylus&scoped=true"
import style1 from "./FiltersBox.vue?vue&type=style&index=1&id=2fb247f8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb247f8",
  null
  
)

export default component.exports